const globalVariables = {
  pensionbeeContactEmailAddress: 'contact@pensionbee.com',
  pensionbeeContactPhoneNumber: '020 3457 8444',
};

export default globalVariables;
